module.exports = __webpack_public_path__ + "img/kyoto.236a140a.jpg";